module.exports = __webpack_public_path__ + "img/ex1.3b43550c.png";